import { useEffect, useState } from "react";
import { LocalizedLink } from "gatsby-plugin-i18n-l10n";
import { useIntl } from "react-intl";

import * as s from "./CookieConsentBanner.module.scss";
import { ROUTES } from "../../../config";
import { useCookieConsent } from "../../contexts/CookieConsentContext";

export const CookieConsentBanner = () => {
  const { formatMessage } = useIntl();
  const [hydrated, setHydrated] = useState(false);

  const { consent, acceptAll, rejectAnalytics } = useCookieConsent();

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated || consent.chosen) {
    return null;
  }

  return (
    <div className={s.banner}>
      <p className={s.text}>
        {formatMessage(
          {
            id: "We use cookies to provide you with the best possible experience and to enhance our online services. Cookies that are not strictly necessary, including analytics cookies, will only be set with your consent. For more information, please see our {privacyPolicyLinkParam}.",
          },
          {
            privacyPolicyLinkParam: (
              <LocalizedLink to={ROUTES.PRIVACY_POLICY}>
                {formatMessage({ id: "Privacy Policy" })}
              </LocalizedLink>
            ),
          },
        )}
      </p>
      <button onClick={rejectAnalytics} className={s.reject}>
        {formatMessage({ id: "Reject" })}
      </button>
      <button onClick={acceptAll} className={s.accept}>
        {formatMessage({ id: "Accept" })}
      </button>
    </div>
  );
};
